import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function ValueItem({ icon, label, children }) {
  return (
    <div className="d-flex justify-content-between align-items-start mt-3">
      <IconWithText
        iconClassName={`${icon} smaller-icon bg-gray-700`}
      >
        {label}
      </IconWithText>

      <small className="ms-2 text-end text-gray-600">
        {children}
      </small>
    </div>
  );
}

ValueItem.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

ValueItem.defaultProps = {
  children: null,
};
